/**
 * Valores por defecto para todos los colores configurables del tema.
 * Estos valores se usan cuando no hay configuración personalizada.
 * Todos los colores aquí son editables desde ThemeSettings.
 */

/**
 * Colores por defecto para roles de usuario
 */
export const DEFAULT_ROLE_COLORS = {
  SUPERUSER: "#000000", // Negro para super administrador (máxima autoridad)
  OWNER: "gold", // Dorado para propietario (premium)
  ADMIN_LOCAL: "#722ed1", // Púrpura profesional para admin local
  MANAGER: "#1890ff", // Azul profesional para gerente
  EMPLOYEE: "#52c41a", // Verde para empleado general
  CAJERO: "#fa541c", // Naranja para cajero (dinero/ventas)
  METER: "#13c2c2", // Turquesa para medidor (técnico)
  RECEIVER: "#eb2f96", // Rosa profesional para recepcionista
  DRIVER: "#faad14", // Amarillo para conductor (transporte)
  WAITER: "#2f54eb", // Azul índigo para mesero (servicio elegante)
  OPERATOR: "#d4380d", // Volcano para operador
  VIEWER: "#8c8c8c", // Gris para solo lectura
  APR: "#1890ff", // Azul para APR (gestión hídrica)
  NUTRITION_LABELER: "#52c41a", // Verde para etiquetador nutricional
};

/**
 * Colores semánticos por defecto (success, warning, error, info)
 */
export const DEFAULT_SEMANTIC_COLORS = {
  success: "#52c41a", // Verde para éxito
  warning: "#faad14", // Amarillo para advertencia
  error: "#ff4d4f", // Rojo para error
  info: "#1890ff", // Azul para información
};

/**
 * Colores de gradientes por defecto
 */
export const DEFAULT_GRADIENT_COLORS = {
  start: "#667eea", // Color inicial del gradiente
  end: "#764ba2", // Color final del gradiente
};

/**
 * Colores de estado por defecto (inventario, mediciones, etc.)
 */
export const DEFAULT_STATUS_COLORS = {
  critical: "#ff4d4f", // Rojo para estado crítico
  low: "#faad14", // Amarillo para estado bajo
  normal: "#52c41a", // Verde para estado normal
  high: "#13c2c2", // Turquesa para estado alto
  outOfStock: "#ff7875", // Rojo claro para agotado
  inStock: "#52c41a", // Verde para en stock
};

/**
 * Función helper para obtener todos los colores por defecto
 */
export const getDefaultThemeColors = () => ({
  roleColors: { ...DEFAULT_ROLE_COLORS },
  semanticColors: { ...DEFAULT_SEMANTIC_COLORS },
  gradientColors: { ...DEFAULT_GRADIENT_COLORS },
  statusColors: { ...DEFAULT_STATUS_COLORS },
});

